import { orderDomainStore } from '../../store';
export const getOrderSelections = () => orderDomainStore.data.selections;
//# sourceMappingURL=get-order-selections.js.map